
class CBScale {
  constructor(data_range, canvas_range) {
    this.canvas_range = canvas_range
    this.data_range = data_range
  }

  position(data_value) {
    console.error("Not Implemented")
  }

  value_list(interval) {
    console.error("Not Implemented")
  }

  destroy() {
    this.data_range = null
    this.canvas_range = null
    return null
  }
}


class CBScaleFix extends CBScale {
  position() {
    return this.canvas_range
  }
}


class CBScaleLiner extends CBScale {
  position(data_value) {
    try {
      return ((data_value - this.data_range[0]) / (this.data_range[1] - this.data_range[0])) *
          (this.canvas_range[1] - this.canvas_range[0]) +
          this.canvas_range[0]
    }
    catch (e) {
      return null
    }
  }

  rate(data_value) {
    let v = ((data_value - this.data_range[0]) / (this.data_range[1] - this.data_range[0]))
    if (v > 1) { return 1 }
    if (v < 0) { return 0 }
    return v
  }

  canvas_size() {
    if (this.canvas_range && this.canvas_range.length == 2) {
      return this.canvas_range[1] - this.canvas_range[0]
    }
    return 0
  }

  value_list(interval, number_of_ticks) {
    /**
     * number_of_ticks: 需要有幾個tick間隔
     * 會得到number_of_ticks+1個tick
     */
    if (!interval) {
      try {
        if (number_of_ticks) {  // 不該為0
          interval = (this.data_range[1] - this.data_range[0]) / number_of_ticks
        }
        else {
          interval = (this.data_range[1] - this.data_range[0]) / 5
        }
      }
      catch (error) {
        console.warn(error)
        interval = 1
      }
    }
    let dlist = []
    if (this.data_range[1] < this.data_range[0]) {
      if (interval > 0) { interval *= -1 }
      for (let v=this.data_range[0]; v>=this.data_range[1]; v+=interval) {
        dlist.push(v)
      }
    }
    else {
      if (interval < 0) { interval *= -1 }
      for (let v=this.data_range[0]; v<=this.data_range[1]; v+=interval) {
        dlist.push(v)
      }
    }
    return dlist
  }
}


class CBScaleTime extends CBScaleLiner {
  constructor(data_range, canvas_range) {
    super(data_range, canvas_range)
    this.data_range = [data_range[0].valueOf(), data_range[1].valueOf()]
  }

  position(data_value) {
    try {
      data_value = data_value.valueOf()
      return ((data_value - this.data_range[0]) / (this.data_range[1] - this.data_range[0])) *
          (this.canvas_range[1] - this.canvas_range[0]) +
          this.canvas_range[0]
    }
    catch (e) {
      return null
    }
  }

  rate(data_value) {
    data_value = data_value.valueOf()
    let v = ((data_value - this.data_range[0]) / (this.data_range[1] - this.data_range[0]))
    if (v > 1) { return 1 }
    if (v < 0) { return 0 }
    return new Date(v)
  }

  value_list(interval) {
    if (!interval) {
      // unit: minutes, default 1 hour
      interval = 60
    }
    interval = interval * 60 * 1000
    let dlist = []
    if (this.data_range[1] < this.data_range[0]) {
      if (interval > 0) { interval *= -1 }
      for (let v=this.data_range[0]; v>=this.data_range[1]; v+=interval) {
        dlist.push(new Date(v))
      }
    }
    else {
      if (interval < 0) { interval *= -1 }
      for (let v=this.data_range[0]; v<=this.data_range[1]; v+=interval) {
        dlist.push(new Date(v))
      }
    }
    return dlist
  }
}


export {
  CBScaleFix, CBScaleLiner, CBScaleTime
}



// WEBPACK FOOTER //
// ./src/assets/cb/cb-chart/cb_scale.js